// extracted by mini-css-extract-plugin
export default {"card":"Card_card__Xtrx0","cartBtn":"Card_cartBtn__EniCV","favorite":"Card_favorite__fjnHz","added":"Card_added__l2poS"};